// extracted by mini-css-extract-plugin
module.exports = {"splitter":"BuildingsFilterMobile_splitter__Qe_Wh","actions":"BuildingsFilterMobile_actions__Dk0FS"};